const galleryItems = [
  {
    src: "/images/kitchen/cooking-range.webp",
    title: "Complete Cooking Line",
    location: "Ranges, hot stations & canopy",
    size: "col-span-2 row-span-1",
  },
  {
    src: "/images/kitchen/worktops.webp",
    title: "Stainless Worktops & Sinks",
    location: "Custom counters with upstands",
    size: "col-span-1 row-span-2",
  },
  {
    src: "/images/kitchen/shelving.webp",
    title: "Dry & Cold Storage Shelving",
    location: "Wall-mounted & freestanding",
    size: "col-span-1 row-span-1",
  },
  {
    src: "/images/kitchen/sinks.webp",
    title: "Pot-Wash Station",
    location: "Double-bowl sink with drainer",
    size: "col-span-1 row-span-1",
  },
  {
    src: "/images/kitchen/refrigeration.webp",
    title: "Refrigeration & Cold Room",
    location: "Under-counter fridges & walk-in",
    size: "col-span-2 row-span-1",
  },
];

export default function KitchenGallery() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">Our Work</span>
          <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight">
            Project Gallery
          </h2>
          <p className="text-gray-500 text-sm mt-4 max-w-lg mx-auto leading-relaxed">
            A selection of commercial kitchen installations delivered across Kenya — hotels, restaurants, hospitals, schools, and food processing plants.
          </p>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[220px]">
          {galleryItems.map((item, i) => (
            <div
              key={i}
              className={`relative overflow-hidden rounded-lg group cursor-pointer ${item.size}`}
            >
              <img
                src={item.src}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-white font-bold text-sm uppercase tracking-wide">{item.title}</p>
                <p className="text-teal-300 text-xs mt-1 flex items-center gap-1">
                  <i className="ri-map-pin-line"></i>
                  {item.location}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm mb-4">Have a project in mind? Let&apos;s talk.</p>
          <a
            href="#inquiry"
            onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
            className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap inline-block"
          >
            Discuss Your Project
          </a>
        </div>
      </div>
    </section>
  );
}
